import { MarkNode } from '@lexical/mark'
import { ListItemNode, ListNode } from '@lexical/list'
import { HeadingNode, QuoteNode } from '@lexical/rich-text'
import { LinkNode } from '@lexical/link'
import { TableNode, TableCellNode, TableRowNode } from '@lexical/table'

export const LEXICAL_NODES = [MarkNode, HeadingNode, ListNode, ListItemNode, QuoteNode, LinkNode, TableNode, TableCellNode, TableRowNode]
